import moment from 'moment-timezone'
import langTranslation from '../langTranslation.json'


const getTranslationTime = (id, trans, dateString, def=false) => {
    const translationTime = langTranslation.translationTime
    const timezone = trans.timezone
    const currentLang = trans.currentLang  ? trans.currentLang : false 
    let transString

    if (moment().year() !== moment(dateString).year() && id !== "showtimePerformance" ){
        id = 'performanceDatesNextYear'
    }

    if(timezone && translationTime[id] && currentLang && translationTime[id].format[currentLang]) {
        const momentDate = moment.tz(dateString, timezone)

        transString = momentDate.format(translationTime[id].format[currentLang])
    } else {
        const errorText = `No time translation for id ${id}`

        if(def) {
            console.warn(errorText)
            transString = def
        } else {
            console.error(errorText)
            transString = "ERROR"
        }
    }

    return transString
}

export default getTranslationTime

